import { FC } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

interface TruncatedSectionTitleProps {
  name: string;
}

const SECTION_TITLE_CHATS_LIMIT = 90;

export const TruncatedSectionTitle: FC<TruncatedSectionTitleProps> = ({
  name,
}) => {
  const isTruncated = name.length > SECTION_TITLE_CHATS_LIMIT;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="text-zinc-500 text-[12px] font-inter text-center truncate whitespace-nowrap pb-2">
          {name.slice(0, SECTION_TITLE_CHATS_LIMIT)}
          {isTruncated && "..."}
        </span>
      </TooltipTrigger>
      {isTruncated && (
        <TooltipContent className="max-w-[400px]">{name}</TooltipContent>
      )}
    </Tooltip>
  );
};
